/** 発送日のみ扱う出荷形態（表示文字列・完全一致） */
export const SINGLE_DATE_SHUKKA_TYPES = Object.freeze(['配達・発送', '引取・工場渡し']);

/**
 * 単一日付（発送日のみ）の出荷形態か。
 * @param {string|null|undefined} shukkaType
 */
export function isSingleDateShukkaType(shukkaType) {
  if (shukkaType == null || shukkaType === '') return false;
  return SINGLE_DATE_SHUKKA_TYPES.includes(String(shukkaType).trim());
}

/**
 * 着日入力を出してよい出荷形態か（単一日付以外。空・不明は二日付扱い）。
 * @param {string|null|undefined} shukkaType
 */
export function allowsArrivalDateInput(shukkaType) {
  return !isSingleDateShukkaType(shukkaType);
}

/**
 * 候補行の出荷形態がすべて着日入力可か。
 * @param {Array<{ shukka_type?: string|null }|string|null|undefined>} rowsOrTypes
 */
export function allAllowArrivalDateInput(rowsOrTypes) {
  const list = Array.isArray(rowsOrTypes) ? rowsOrTypes : [];
  if (list.length === 0) return true;
  return list.every((item) => {
    const t = item && typeof item === 'object' ? item.shukka_type : item;
    return allowsArrivalDateInput(t);
  });
}

/**
 * 依頼書の着日セル表示。単一日付なら出荷形態、否则着日。
 * @param {{ shukkaType?: string|null, arrivalDate?: string|null, formatDate?: (v: string|null|undefined) => string }} args
 */
export function formatRequestFormArrivalCell({ shukkaType, arrivalDate, formatDate }) {
  if (isSingleDateShukkaType(shukkaType)) {
    const label = String(shukkaType).trim();
    return label || '-';
  }
  if (typeof formatDate === 'function') {
    return formatDate(arrivalDate);
  }
  if (arrivalDate == null || arrivalDate === '') return '-';
  return String(arrivalDate);
}
